import { APP_INITIALIZER, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { LocalStorageService } from '../local-storage/local-storage.service';
import mixpanel from 'mixpanel-browser';
import { environment } from 'src/environments/environment';

export function mixpanelAppInitializer(localStorageService: LocalStorageService, platformId: Object) {
  return () => {
    // Only initialize Mixpanel in browser environment
    if (!isPlatformBrowser(platformId)) {
      return;
    }

    // Initialize Mixpanel first
    mixpanel.init(environment.mixpanelToken, {
      debug: environment.logMixpanel,
      track_pageview: true,
      persistence: 'localStorage',
    });

    const existingSessionId = localStorageService.get('session_id');
    if (!existingSessionId) {
      const newSessionId = crypto.randomUUID();
      localStorageService.save('session_id', newSessionId);
      mixpanel.register({'session_id': newSessionId});
    } else {
      mixpanel.register({'session_id': existingSessionId});
    }

    // Capture UTMs and referrer
    const urlParams = new URLSearchParams(window.location.search);
    const initialReferrer = document.referrer;

    const firstTouchProps: { [key: string]: string } = {};
    const lastTouchProps: { [key: string]: string } = {};

    // UTMs
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(utmKey => {
      const value = urlParams.get(utmKey);
      if (value) {
        firstTouchProps[`initial_${utmKey}`] = value;
        lastTouchProps[`latest_${utmKey}`] = value;
      }
    });

    // Initial Referrer
    if (initialReferrer) {
      firstTouchProps['initial_referrer'] = initialReferrer;
    }

    // Register first-touch properties (only once)
    mixpanel.register_once(firstTouchProps);

    // Register last-touch properties (on every session)
    mixpanel.register(lastTouchProps);
  };
}

